import { createSelector } from 'reselect'
import * as cmsSelector from 'services/cms/selector'
import {
  getRequestError,
  requestIsFetchingCMSSelector,
} from 'services/Request/selectors'
import { CMS_DATA_REQUESTED } from 'services/cms/actionTypes'

export const selector = createSelector(
  [
    cmsSelector.cms,
    getRequestError(CMS_DATA_REQUESTED),
    requestIsFetchingCMSSelector,
  ],
  (cms, error, isFetchingCMS) => ({
    cms,
    //isCMSError: error && isUnavailableError(error),
    isFetchingCMS,
  }),
)
